import { formatCurrency } from '../lib/formatCurrency.js';

function Row({ label, value, strong = false }) {
  const isNegative = typeof value === 'number' && value < 0;
  const valueColorClass = isNegative
    ? 'text-rose-700'
    : strong
    ? 'text-slate-950'
    : 'text-slate-800';

  return (
    <div className="flex items-center justify-between gap-4 py-3">
      <span className={strong ? 'text-sm font-semibold text-slate-950' : 'text-sm text-slate-600'}>{label}</span>
      <span className={`text-sm ${strong ? 'font-bold' : 'font-semibold'} ${valueColorClass}`}>
        {formatCurrency(value)}
      </span>
    </div>
  );
}

export default function FeeBreakdown({ result }) {
  return (
    <section className="panel-card p-5 sm:p-6">
      <h2 className="text-xl font-semibold tracking-normal text-slate-950">Rincian Perhitungan</h2>

      <div className="mt-5 divide-y divide-slate-100">
        <Row label="Gross Sales" value={result.grossSales} />
        <Row label="Diskon + Voucher Seller" value={result.totalSellerDiscount} />
        <Row label="Net Product Value" value={result.netProductValue} strong />
      </div>

      <div className="mt-5 rounded-lg bg-slate-50 p-4">
        <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Fee Marketplace</h3>
        <div className="mt-2 divide-y divide-slate-200">
          <Row label="Admin / Platform Fee" value={result.adminFee} />
          <Row label="Program Fee" value={result.programFee} />
          {result.programDetails.map((program) => (
            <div key={program.key} className="flex items-center justify-between gap-4 py-2 pl-3">
              <span className="text-xs text-slate-500">{program.label}</span>
              <span className="text-xs font-semibold text-slate-700">{formatCurrency(program.amount)}</span>
            </div>
          ))}
          <Row label="Affiliate Fee" value={result.affiliateFee} />
          <Row label="Ads Fee" value={result.adsFee} />
          <Row label="Order Processing Fee" value={result.orderProcessingFee} />
          <Row label="Total Marketplace Fees" value={result.totalMarketplaceFees} strong />
        </div>
      </div>

      <div className="mt-5 divide-y divide-slate-100">
        <Row label="Total HPP" value={result.totalHpp} />
        <Row label="Total Packing Cost" value={result.totalPackingCost} />
        <Row label="Net Payout" value={result.netPayout} strong />
        <Row label="Net Profit" value={result.netProfit} strong />
      </div>
    </section>
  );
}
